/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { Grid, TextField } from '@mui/material';
import React, { useRef, useEffect } from 'react';

export default function GoogleSearch({ onChange, value, onBlur, isLoaded, id, ...rest }) {
  const ref = useRef(null);

  const handleScriptLoad = (ref) => {
    const autoComplete = new window.google.maps.places.Autocomplete(ref.current);
    autoComplete.addListener('place_changed', () => handlePlaceSelect(autoComplete));
  };

  const handlePlaceSelect = (autoComplete) => {
    const addressObject = autoComplete.getPlace();
    const addressComponents = addressObject?.address_components || [];

    const getComponent = (type) =>
      addressComponents.find((component) => component.types.includes(type))?.long_name || '';

    const addressDetails = {
      address: addressObject?.formatted_address || '',
      city: getComponent('locality'),
      state: getComponent('administrative_area_level_1'),
      country: getComponent('country'),
      zipcode: getComponent('postal_code'),
      latitude: addressObject?.geometry?.location?.lat(),
      longitude: addressObject?.geometry?.location?.lng(),
    };

    onChange(addressDetails);
  };

  useEffect(() => {
    if (isLoaded) {
      handleScriptLoad(ref);
      setTimeout(() => {
        if (ref.current) {
          ref.current.setAttribute('autocomplete', 'new-password');
        }
      }, 1000);
    }
  }, [isLoaded]);

  return (
    <Grid item xs={12}>
      <TextField
        id={id ?? 'address'}
        label="Search address"
        onBlur={onBlur}
        inputRef={ref}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        variant="outlined"
        sx={{ width: '100%', textAlign: 'left' }}
        SelectProps={{
          MenuProps: { disableScrollLock: true },
        }}
        {...rest}
        autoComplete="new-password"

        // error={!!errors?.user?.message}
        // helperText={errors?.user?.message}
      />
    </Grid>
  );
}
